<svg width="11" height="14" viewBox="0 0 11 14" fill="#000000"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M0 14L11 7L0 0V14Z" fill="currentColor" />
</svg>
